import _ from 'lodash';
class ProxyDefaultValue {
    get featureList() { return _.get(window, 'zPREFACE.pageConfig.featureList'); }
    get siteRegion() { return _.get(window, 'zPREFACE.accountInfo.site_region') || 'CN'; }
    get isSpecialIp() { return _.get(window, 'zPREFACE.globalConfig.userInfo.isSpecialIp'); }
    get previewNumber() { return _.get(window, 'zPREFACE.globalConfig.featureConfigs.previewNumber', 1500); }
    get usedByAnchorDeepView() { return _.get(window, 'zPREFACE.usedByAnchorInfo.PATENT_DEEP_VIEW', {}); }
    get deepViewLabOn() { return _.get(window, 'zPREFACE.usedByAnchorInfo.PATENT_DEEP_VIEW.used', false); }
    get legalConfig() { return _.get(window, 'zPREFACE.legalConfig', undefined) || []; }
    get maxQueryLength() { return _.get(window, 'zPREFACE.globalConfig.featureConfigs.maxQueryLength', 15000); }
    get encryptId() { return _.get(window, 'zPREFACE.globalConfig.userInfo.encryptId') || ''; }
    get selfEmail() { return _.get(window, 'zPREFACE.accountInfo.email', ''); }
    get selfMobileNumber() { return _.get(window, 'zPREFACE.accountInfo.mobile_number', ''); }
    get labHiResImageForPVP() { return _.get(window, 'zPREFACE.usedAnchorInLab.HI_RES_IMAGE', {}); }
    get labHiResImageForSRP() { return _.get(window, 'zPREFACE.usedByAnchorInfo.HI_RES_IMAGE', {}); }
    get familyAnalysis() { return _.get(window, 'zPREFACE.acl.familyAnalysis', false); }
    get collapseField() { return _.get(window, 'zPREFACE.userSetting.setting.searchSetting.collapse.field', 'ALL'); }
}
export const proxyDefaultValue = new ProxyDefaultValue();
